<template>
  <div :class="$style.container">
    <GoBack :href="accountDashboardLink" :text="$t('button.back.accountOverview')" />
    <div :class="$style.headingContainer">
      <h1 :class="$style.heading">{{ $t('overview.header.title') }}</h1>
      <NewPropertyButton v-if="showAddButton" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import GoBack from '@/components/common/GoBack/GoBack.vue';
import NewPropertyButton from '@/components/common/NewPropertyButton/NewPropertyButton.vue';
import { isPlatformIs24 } from '@/helpers/Platform/Platform';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

export interface Props {
  showAddButton?: boolean;
}

withDefaults(defineProps<Props>(), {
  showAddButton: true,
});

const { locale } = useI18n();

const accountDashboardLink = computed<string>(() => {
  const urlSuffix = isPlatformIs24() ? 'account-overview' : 'overview';
  return `${import.meta.env.VUE_APP_ACCOUNT_VIEW_BASE_URL}/${locale.value}/${urlSuffix}`;
});
</script>

<style lang="scss" module>
@use '@/assets/variables' as *;
.container {
  display: flex;
  flex-direction: column;
  gap: $space-100;
}

.headingContainer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.heading {
  @include heading-1;
  @include vertical-margin(0, $space-150);
}
</style>
